/*                                                                              */
/*                                                  */

export const browser = [
  "Chrome",
  "Edge",
  "Firefox",
  "MobileSafari",
  "Opera",
  "Safari",
  "App_WebView",
];

export const deviceTypes = ["desktop", "mobile", "tablet"];

export const pageCluster = [
  "AftersalesOrders",
  "AftersalesReturns",
  "Artikeldetailseite",
  "Artikelkombiseite",
  "BBS",
  "Checkout",
  "ConnectFeedback",
  "ContactComplaint",
  "Einstiegsseite",
  "Login",
  "MYA_Balance",
  "MYA_Dashboard",
  "MYA_Invoices",
  "MYA_Orders",
  "MYA_Profile",
  "MYA_Profile_Data",
  "MYA_Profile_Permissions",
  "MYA_Profile_Security",
  "MYA_UP",
  "Paymentinfo",
  "Produktliste",
  "Registration",
  "Service",
  "Storefront",
  "Suchergebnisseite",
  "User",
  "Warenkorb",
  "Wishlist",
];

/*                                             */
export const rumArray = [
  "rum_domComplete",
];

/*                                             */
export const trackingPIArray = [
  "rum_deviceType",
  "rum_effectiveType",
  "rum_domComplete",
  "rum_supportsTouch",
  "rum_LCPElement",
  "rum_LCPURL",
  "rum_LCPTimeToFirstByte",
  "rum_LCPResourceLoadDelay",
  "rum_LCPResourceLoadDuration",
  "rum_LCPElementRenderDelay",
  "rum_FirstContentfulPaint",
  "rum_LargestContentfulPaint",
  "rum_sfid",
  /*                                                                                         */
];

/**
 *
 *
 *
 */
export const trackingEventArray = [];

/*                                               */
export const userTimingArray = [
  "rum_CumulativeLayoutShift",
  "rum_LargestContentfulPaint",
  "rum_FirstContentfulPaint",
  "rum_InteractionToNextPaint",
  "rum_entryPage",
  "rum_ProductDetailViewVisuallyComplete",
  "rum_reco_orderOverview",
  "rum_RecoDetailViewComplementary",
  "rum_RecoDetailViewProductline",
  "rum_RecoDetailViewAlternative",
  "rum_RecoProductline",
  "rum_reco_wishlist",
  "rum_consent_banner_loading_time",
  "rum_one_trust_sdk_loading_time",
];
